import '../chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}
class Monitoring.Views.Charts.RankingChartView extends Monitoring.Views.Charts.ChartView
  generic_template: JST["backbone/templates/monitoring/charts/generic_ranking"]
  tabs:3
  readyTabs:0

  events:
    'click .value': '_previewSearch'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'
    'click .download-image': 'onClickDownloadImage'
    'blur .results': 'changeResultsQuantity'
    'keypress .results': 'onKeyPressed'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @defaultResults = parseInt(@_settings.resultsAmount) || 10
    @container = @options.container
    @trigger('masonry')

  setSearchQuery: (searchQuery) ->
    @searchQuery = searchQuery

  twitterApi: (settings, template, options={}) ->
    query = @searchQuery.deepCopy()
    query.set('resultsAmount',@defaultResults)
    @ajaxCall(settings.url, query.toJSON(), (response) =>
      container = options.container || @$el
      el = container.find("##{settings.id} .ranking")
      _.each(response, (value, index) =>
        user = new Monitoring.Models.SocialContents.TwitterApiUser(value)
        user.ranking = index
        el.append(template(user: user, settings: settings))
        avatar = new Monitoring.Views.TwitterAvatarView({user})
        el.find("#user-name-#{user.social_network_id()}").append(avatar.render())
      )
      if response.length == 0
        el.parent().find('.no-data').removeClass('hidden')
      container.find("##{settings.id}").find('.processing').removeClass('processing')
      @finish()
      options.callback() if options.callback
    )

  getRankings: (settings) ->
    query = @searchQuery.deepCopy()
    if settings.status
      query.addStatus(settings.status)
    query.set('resultsAmount',@defaultResults)

    @ajaxCall(@url, query.toJSON(), (response) =>
      @handleResponse(response, settings)
    )
    @

  getHashtags: (ranking, hashtag_template) ->
    query = @searchQuery.deepCopy()
    query.set 'resultsAmount', @defaultResults
    @ajaxCall '/monitoring/dashboard/charts/hashtag/', query.toJSON(), (response) =>
      el = @$el.find "##{ranking.id}"
      hashtags = []
      _.each response, (object, index) =>
        object.ranking = index
        hashtags.push(object)
        el.find('.ranking').append(hashtag_template hashtag: object, settings: ranking)
      el.parent().find('.no-data').removeClass('hidden') if hashtags.length == 0
      @$el.find("##{ranking.id}").find('.processing').removeClass('processing')
      @finish()
    @

  getTwitterHashtags: (ranking, hashtag_template) ->
    query = @searchQuery.deepCopy()
    query.set 'resultsAmount', @defaultResults
    query.set 'type', 'twitter'
    @ajaxCall '/monitoring/dashboard/charts/hashtag/', query.toJSON(), (response) =>
      el = @$el.find "##{ranking.id}"
      hashtags = []
      _.each response, (object, index) =>
        object.ranking = index
        hashtags.push(object)
        el.find('.ranking').append(hashtag_template hashtag: object, settings: ranking)
      el.parent().find('.no-data').removeClass('hidden') if hashtags.length == 0
      @$el.find("##{ranking.id}").find('.processing').removeClass('processing')
      @finish()
    @

  handleResponse:(response, settings) =>
    el = @$el.find("##{settings.id} .ranking")
    _.each(response, (value, index) =>
      valueClass = if settings.status && settings.status.toLowerCase() == 'rejected' then ' rejected ' else ''
      el.append(@ranking_template(user: value, settings: settings, value_class:valueClass))
    )
    if response.length == 0
      el.parent().find('.no-data').removeClass('hidden')
    @$el.find("##{settings.id}").find('.processing').removeClass('processing')
    @finish()


  _previewSearch: (event) =>
    @createPreviewDashboard(@getNewQuery(event))

  getNewQuery: (event) ->
    field = $(event.currentTarget).data('field')
    value = $(event.currentTarget).data('value')
    value = { value: value } if field == 'social_network_id' # workaround for livefyre
    query = @searchQuery.deepCopy()
    query.set(field, [value])

    if @getTypeForDrilldownQuery()
      query.set('type', @getTypeForDrilldownQuery())

    status = $(event.currentTarget).data('status')
    query.set('status', [status]) if status? and status != ''
    return query

  getTypeForDrilldownQuery: ->
    null

  finish: =>
    children_height = ($(child).height() for child in @$el.find('.chart').children())
    new_height = Math.max.apply(Math, children_height)
    @$el.height(new_height)
    @$el.removeClass('processing')
    @trigger('masonry')
    @readyTabs += 1
    if @tabs == @readyTabs
      @$el.find('.results').removeClass('disabled')
    @addOpacityToRanking()

    unless @_settings.exportable == false # when its true or undefined
      unless @downloadLinkExists
        @id = new Date().toISOString().replace(/[-:.]/g, '')
        linkToImage = $('<a id="download-' + @id + '" class="download-image" style="position:absolute;top:15px;right:40px;z-index:1;"><i class="fa fa-download" style="font-size:15px;color:#000000"></i></a>')
        @$el.find('#close_chart').before(linkToImage)
        @downloadLinkExists = true

  displayError: =>
    super()
    @$el.css('height', '300px').removeClass('h3')

  ###
  function for update number of results, called on $('.results').blur
  ###
  changeResultsQuantity: (event) ->
    tar = event.currentTarget
    originalValue = tar.value
    parsedValue = parseInt(originalValue)
    if isNaN parsedValue
      tar.value = @defaultResults
      return
    parsedValue = if parsedValue < 1 then 1 else if parsedValue > @maxResults() then @maxResults() else parsedValue
    if @defaultResults != parsedValue then update = true else update = false
    @defaultResults = parsedValue
    tar.value = parsedValue
    if update
      @updateResultsQuantity()

  maxResults: ->
    100

  updateResultsQuantity: ->
    @_settings.resultsAmount = @defaultResults
    @trigger('chartsChange')
    @readyTabs = 0
    @downloadLinkExists = false
    @render()

  onKeyPressed: (evt) =>
    if evt.which == 13 # ENTER
      @changeResultsQuantity(evt)

  addOpacityToRanking: () =>
    tabs = @$el.find('.ranking')
    $.each tabs,(i, tab) ->
      valueEl = $(tab).find('.value')
      $.each valueEl, (i, El) ->
        $(El).css('opacity', 1-(i/(valueEl.length*1.5)))

  onClickDownloadImage: (evt) ->
    evt.stopPropagation()
    @$el.find('.ranking').addClass('html2canvas-fix')
    table = @$el.find('.chart')[0]
    onrendered = (canvas) =>
      @$el.append(canvas)
      @$el.find('canvas').addClass('canvas').hide()
      @downloadCanvas(evt.currentTarget, 'canvas')
      @$el.find('.ranking').removeClass('html2canvas-fix')
      @$el.find('canvas').remove()
    html2canvas(table, onrendered: onrendered, timeout: 30000, useCORS: true)

  downloadCanvas: (link, canvasClass) ->
    link.href = @$el.find('.' + canvasClass)[0].toDataURL()
    link.download = @filename
    @undelegateEvents()
    setTimeout () =>
      link.click()
      @delegateEvents()
    , 800
